import { useQuery } from '@tanstack/react-query';

export function useAttachmentsBulkProcessingStatusQuery({
  attachmentIds,
  enabled = true,
  queryOptions,
}) {
  return useQuery({
    enabled: enabled && attachmentIds.length > 0,
    queryKey: ['attachments', 'bulkProcessingStatus', attachmentIds],
    queryFn: async () => {
      const response = await axios.get('/attachments/bulk_processing_status', {
        params: { ids: attachmentIds },
      });

      return response.data;
    },
    refetchInterval: (data) =>
      data?.data?.attributes?.processed ? false : 2000,
    ...queryOptions,
  });
}
